import { Typography, Grid } from "@mui/material";
import { format } from "date-fns";
import React from "react";
import { CustomerInterface } from "../../Objects/Customer";

export interface MemberRenewDateProps {
    customerData: CustomerInterface
}

const MemberRenewDate: React.FC<MemberRenewDateProps> = ({
    customerData
}) => {
    return (
        <>
            {customerData.renew_date &&
                <Grid container>
                    <Grid item xs={12}>
                        <Typography variant="caption" sx={{color: "#333399"}}>更新日</Typography>
                    </Grid>
                    <Grid item>
                        <Typography variant="body1">{format(new Date(customerData.renew_date), "yyyy年MM月dd日")}</Typography>
                    </Grid>
                </Grid>
            }
        </>
    );
}

export default MemberRenewDate